import React, { useEffect, useMemo, useState } from 'react';
import { accountsService } from '../../services/accountsService';
import './UserLoginTooltip.css';

const VENDOR_ACCOUNT_KEYS = {
  dice: 'dice',
  aspen: 'aspen',
  'belly up': 'aspen',
  'belly up aspen': 'aspen',
  pacha: 'pacha',
  tao: 'tao',
  'get-in': 'get_in',
  'get in': 'get_in',
  get_in: 'get_in',
  seetickets: 'seetickets',
  'see tickets': 'seetickets',
  ticketmaster: 'ticketmaster',
  'ticket master': 'ticketmaster',
  tm: 'ticketmaster',
  axs: 'axs',
  tixr: 'tixr',
};

const accountLoginCache = new Map();

const loadAccountLogin = async (entry) => {
  const vendorKey = VENDOR_ACCOUNT_KEYS[String(entry.vendor || '').trim().toLowerCase()] || '';
  if (!entry.userId) return { success: false, error: 'No assigned user account.' };
  if (!vendorKey) return { success: false, error: 'No login mapping for this vendor.' };

  const cacheKey = `${vendorKey}:${entry.userId}`;
  if (!accountLoginCache.has(cacheKey)) {
    accountLoginCache.set(cacheKey, accountsService.getVendorLogin(vendorKey, entry.userId));
  }
  return accountLoginCache.get(cacheKey);
};

const UserLoginTooltip = (props) => {
  const entries = useMemo(() => (Array.isArray(props.value) ? props.value : []), [props.value]);
  const [results, setResults] = useState([]);
  const [copiedKey, setCopiedKey] = useState('');

  useEffect(() => {
    let active = true;
    setResults([]);
    Promise.all(entries.map(loadAccountLogin)).then((nextResults) => {
      if (active) setResults(nextResults);
    });
    return () => { active = false; };
  }, [entries]);

  if (!entries.length) return null;

  const copyValue = async (value, key) => {
    try {
      await navigator.clipboard.writeText(String(value));
      setCopiedKey(key);
    } catch (error) {
      setCopiedKey('');
    }
  };

  return (
    <div className="events-pnl-user-tooltip">
      <div className="events-pnl-user-tooltip-title">Account Login</div>
      <div className="events-pnl-user-tooltip-list">
        {entries.map((entry, index) => {
          const result = results[index];
          const login = result?.success ? result.item?.login : '';
          const password = result?.success ? result.item?.password : '';
          return (
            <div
              key={`${entry.batchCode || entry.userId}-${entry.username}-${index}`}
              className="events-user-login-tooltip-card"
            >
              <div className="events-user-login-tooltip-heading">
                <span className="events-pnl-user-tooltip-user">{entry.username}</span>
                <span>{[entry.vendor || 'Unknown vendor', entry.platform].filter(Boolean).join(' ')}</span>
                {entry.available != null && (
                  <span>Avail {entry.available} / Sold {entry.sold || 0}</span>
                )}
              </div>
              {!result && <div className="events-user-login-tooltip-status">Loading...</div>}
              {result && !result.success && (
                <div className="events-user-login-tooltip-status">{result.error}</div>
              )}
              {result?.success && !login && !password && (
                <div className="events-user-login-tooltip-status">No login information saved.</div>
              )}
              {login && (
                <div className="events-user-login-tooltip-value">
                  <span>Login</span>
                  <strong>{login}</strong>
                  <button type="button" onClick={() => copyValue(login, `${index}-login`)}>
                    {copiedKey === `${index}-login` ? 'Copied' : 'Copy'}
                  </button>
                </div>
              )}
              {password && (
                <div className="events-user-login-tooltip-value">
                  <span>Password</span>
                  <strong>{password}</strong>
                  <button type="button" onClick={() => copyValue(password, `${index}-password`)}>
                    {copiedKey === `${index}-password` ? 'Copied' : 'Copy'}
                  </button>
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default UserLoginTooltip;
